import { Card, Tag } from "pepsico-ds";
import ReactPlayer from "react-player";
import ImagePreview from "../common/ImagePreview";
import JsonViewer from "../common/JsonViewer";
import "./performanceDetails.scss";

const PerformanceDetailCard = ({ label, value, type }) => {
  const shouldRenderTag = ["status", "source", "tags"].includes(label.toLowerCase());
  const shouldRenderImage =
    label.toLowerCase().includes("image") || type === "image";
  const shouldRenderVideo = type === "video";
  const shouldRenderAudio = type === "audio";
  const shouldRenderSurvey = type === "survey";

  const isArrayValue = Array.isArray(value);

  const getTagColor = (val) => {
    const colorMap = {
      approved: "Green-150",
      pending: "Yellow-150",
      rejected: "Red-150",
      failed: "Red-400",
    };

    return colorMap[val] || "Gray-100";
  };

  const renderTags = () => {
    if (isArrayValue) {
      return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {value.map((val, index) => (
            <Tag
              key={`${label}-${index}`}
              text={val}
              color={getTagColor(val?.toLowerCase())}
              isCopyable={false}
            />
          ))}
        </div>
      );
    }

    return (
      <Tag
        text={value}
        color={getTagColor(value?.toLowerCase())}
        isCopyable={false}
      />
    );
  };

  const renderContent = () => {
    if (shouldRenderVideo) {
      if (!value || value === "-") {
        return <h5 style={{ fontWeight: "normal" }}>No video available</h5>;
      }
      return (
        <div className="video-container">
          <ReactPlayer src={value} controls />
        </div>
      );
    } else if (shouldRenderAudio) {
      if (!value || value === "-") {
        return <h5 style={{ fontWeight: "normal" }}>No audio available</h5>;
      }
      return (
        <div className="audio-container">
          <ReactPlayer src={value} controls />
        </div>
      );
    } else if (shouldRenderSurvey && Array.isArray(value)) {
      return (
        <table className="survey-questions-table">
          <thead>
            <tr>
              <th>Questions</th>
              <th>Answers</th>
            </tr>
          </thead>
          <tbody>
            {value.map((field, index) => (
              <tr key={`${field.key}-${index}`}>
                <td>{field.key || "-"}</td>
                <td>{field.value || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    } else if (shouldRenderImage) {
      if (!value) {
        return <h5 style={{ fontWeight: "normal" }}>No image available</h5>;
      }

      const imageSrc =
        value.startsWith("data:image") ||
        value.startsWith("http://") ||
        value.startsWith("https://")
          ? value
          : `data:image/jpeg;base64,${value}`;

      return <ImagePreview imageSrc={imageSrc} alt={label} />;
    } else if (shouldRenderTag) {
      return renderTags();
    } else if (label.toLowerCase() === "json") {
      return <JsonViewer data={value} />;
    } else if (isArrayValue && label === "Outcomes") {
      // Handle the combined outcomes format
      return (
        <div>
          <ul>
            {value.map((outcome, index) => (
              <li key={`${outcome.name}-${outcome.value}-${index}`}>
                <h5 style={{ fontWeight: "normal" }}>
                  {outcome.name}: {outcome.value}
                </h5>
              </li>
            ))}
          </ul>
        </div>
      );
    } else if (isArrayValue && label === "Survey Questions") {
      // Handle survey questions and answers as a table
      return (
        <table className="survey-questions-table">
          <thead>
            <tr>
              <th>Questions</th>
              <th>Answers</th>
            </tr>
          </thead>
          <tbody>
            {value.map((field, index) => (
              <tr key={`${field.key}-${index}`}>
                <td>{field.key || "-"}</td>
                <td>{field.value || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    } else {
      return (
        <h5 style={{ fontWeight: "normal" }}>
          {isArrayValue ? value.join(", ") : value}
        </h5>
      );
    }
  };

  const shouldHideLabel = shouldRenderImage && !type;
  const shouldUsePadding = !shouldRenderImage || type === "image";

  return (
    <Card
      border
      style={{
        backgroundColor: "#EFF5FC",
        padding: shouldUsePadding ? "15px" : "0px",
      }}
    >
      {!shouldHideLabel && <h5>{label}</h5>}
      {renderContent()}
    </Card>
  );
};

export default PerformanceDetailCard;
